const URLs = {
  HOMEPAGE: 'https://bitrise.io/',
  BITRISE_INSIGHTS: 'https://bitrise.io/platform/devops/insights',
  RELEASE_MANAGEMENT: 'https://bitrise.io/platform/devops/release-management',
  RELEASE_MANAGEMENT_PRICING: 'https://bitrise.io/platform/devops/release-management#pricing',

  DEMO_FORM: 'https://bitrise.io/demo',
  CONTACT_SALES: 'https://bitrise.io/contact',
  CONTACT_SUPPORT: 'https://bitrise.io/contact',
  SUPPORT_CENTER: 'https://support.bitrise.io/',

  STATUS_PAGE: 'https://status.bitrise.io/',

  DOCUMENTATION: 'https://docs.bitrise.io/',
  API_DOCUMENTATION: 'https://docs.bitrise.io/en/bitrise-ci/api/api-overview.html',
  BITRISE_CI_GETTING_STARTED: 'https://docs.bitrise.io/en/bitrise-ci/getting-started/getting-started.html',
  BUILD_CACHE_GETTING_STARTED:
    'https://docs.bitrise.io/en/bitrise-build-cache/getting-started-with-the-build-cache/getting-started-with-the-build-cache',
  BUILD_HUB: 'https://docs.bitrise.io/en/bitrise-build-hub',
  BUILD_HUB_GETTING_STARTED:
    'https://docs.bitrise.io/en/bitrise-build-hub/build-hub-for-github-actions/configuring-build-hub-for-github-actions',
  RDE_GETTING_STARTED: 'https://docs.bitrise.io/en/bitrise-rde/getting-started/quickstart',
  RELEASE_MANAGEMENT_GETTING_STARTED:
    'https://docs.bitrise.io/en/release-management/getting-started-with-release-management/getting-started-with-release-management',
  BITRISE_MCP: 'https://docs.bitrise.io/en/bitrise-platform/ai/bitrise-mcp',

  PRICING: 'https://bitrise.io/pricing',
  PRICING_BUILD_CACHE: 'https://bitrise.io/pricing#remote-build-cache',
  SECURITY_POLICY: 'https://bitrise.io/platform/devops/security',
  LEGAL: 'https://bitrise.io/legal',
  TERMS_OF_SERVICE: 'https://go.bitrise.io/terms-of-service',
  PRIVACY_POLICY: 'https://go.bitrise.io/privacy-policy',
  COOKIE_POLICY: 'https://bitrise.io/cookie-policy',
  COMMUNICATION_PREFERENCES: 'https://bitrise.io/communication-preference-center',

  INTEGRATIONS: 'https://bitrise.io/integrations',
  ROADMAP: 'https://bitrise.io/roadmap',
  CHANGELOG: 'https://bitrise.io/changelog',
  COMMUNITY_FORUM: 'https://discuss.bitrise.io/',

  WORKFLOW_RECIPES: 'https://github.com/bitrise-io/workflow-recipes',
  BLOG_PRODUCT_UPDATES: 'https://bitrise.io/blog/categories/product-updates',
  BLOG_BITRISE_COMMUNITY: 'https://bitrise.io/blog/categories/bitrise-community',
};

export default URLs;
